import { apiClient } from ".";
import { useMutation } from "@tanstack/react-query";
import { captureException } from "@sentry/react";
import { StartLoginParams } from "@/types";

export const startLogin = async ({ nonce, returnPath }: StartLoginParams) => {
  const response = await apiClient({
    url: `/auth/auth`,
    method: "POST",
    data: {
      authText: "Jag identifierar mig mot Sambla Group AB",
      nonce,
      returnPath,
    },
  });
  return response.data;
};

export const useStartLogin = () =>
  useMutation({
    onError: (error) => {
      captureException(error, {
        tags: {
          operation: "startLogin",
          errorType: error.name || "UnknownError",
        },
        extra: {
          apiEndpoint: "/auth/auth",
          errorMessage: error.message,
        },
        level: "error",
      });
    },
    mutationFn: ({ nonce, returnPath }: StartLoginParams) =>
      startLogin({ nonce, returnPath }),
  });
